// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { startOfISOWeekYear as fn } from "../startOfISOWeekYear.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const startOfISOWeekYear = convertToFP(fn, 1);

// Fallback for modularized imports:
export default startOfISOWeekYear;
